module.exports = __webpack_public_path__ + "img/e.62c3a3b6.jpg";